import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualRequestsPage() {
    return <MarkdownDocPage title="Requests" markdownUrl="/docs/user-manual/pages/requests.md" />;
}

